module.exports = __webpack_public_path__ + "img/5.ca658bcd.jpg";